import React from 'react';
import { makeStyles } from '@material-ui/styles';

import { ThemeButton, Translation } from '../../common';

import { useAppWidthClass } from '../../../utils/hooks';

import image from '../../../assets/img/zip-code/troy-security.png';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '32px',
    '& > :not(:last-child)': {
      marginBottom: '24px'
    }
  },
  text: {
    margin: 0,
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'center'
  },
  img: {
    transform: 'rotate(-4.5deg)'
  },
  imgWrapper: {
    position: 'absolute',
    transform: 'translate(-170px, -40px)',
    marginBottom: '0 !important'
  },
  imgWrapperMobile: {
    textAlign: 'center'
  },
  button: {
    width: '100%'
  }
}));

const ZipCodeHelper = ({ onButtonClick }) => {
  const classes = useStyles();
  const { isMobileWidth } = useAppWidthClass();

  return (
    <div className={classes.wrapper}>
      <div
        className={
          isMobileWidth ? classes.imgWrapperMobile : classes.imgWrapper
        }
      >
        <img src={image} className={classes.img} alt="leela-secure" />
      </div>
      <Translation className={classes.text} component="p">
        ZIP_LOGIN_HELP_COPY
      </Translation>
      <ThemeButton
        onClick={onButtonClick}
        className={classes.button}
        id="page.home.component.zip-code-helper.button"
        color="primary"
        variant="contained"
        textKey="ZIP_LOGIN_GOTIT_BUTTON_LABEL"
        startIcon="confirm"
        startIconColor="primaryContrast"
      />
    </div>
  );
};

export default ZipCodeHelper;
